import React from 'react';

import { Container } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { PageTitle } from '../../../shared/components/ui-components';
import { getRouteParam } from '../../../shared/utils/angularUtils';
import { useRecipeFormInitialValues } from './hooks/useRecipeFormInitialValues';
import { RecipeForm } from './RecipeForm/RecipeForm';

const NgzRecipeForm = () => {
  const id = getRouteParam('id');
  const recipeId = id ? Number(id) : undefined;

  const initialData = useRecipeFormInitialValues(recipeId);

  // the mode comes from the loaded recipe, not the route: `/add-recipe/:id` clones a recipe
  const isEdit = !!(recipeId && initialData?.recipe?.editable);

  return (
    <Container>
      {initialData && (
        <>
          <PageTitle title={isEdit ? 'Edit Recipe' : 'Add Recipe'} />
          <RecipeForm initialData={initialData} isEdit={isEdit} />
        </>
      )}
    </Container>
  );
};

angularizeWithProviders(NgzRecipeForm, 'ngzRecipeForm', {});
